

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'setting_';

export default {
  path: routePre + '/setting',
  name: 'setting',
  header: 'setting',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	
	{
	  path: 'index',
	  name: `${pre}index`,
	  meta: {
	    auth: ['setting'],
	    title: '系统配置',
	  },
	  component: () => import('@/pages/setting/index'),
	},
	
	
  ],
};
